import CustomerBaseController from '../common/customer.base.controller'
import ServiceOptionController from '../common/service_options/service_option.controller'
import AppConstants from "../../../../../config/app.constants";

const LIMIT = 10;
const MAXLIMIT = 1000;
class CustomerCreateController extends CustomerBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, CustomerService, Modal, $translate, ContractService, $q, $scope, CommonLayoutService, ContractTypeService, BillableEventsService) {

		super(Auth, $state, User, CustomerService, Modal, $translate, $scope)
		this.CustomerService = CustomerService;
		this.ContractService = ContractService;
		this.$q = $q;
		this.ContractTypeService = ContractTypeService;
		this.CommonLayoutService = CommonLayoutService;
		this.BillableEventsService = BillableEventsService;
		this.billingEventOptions = [];

		this.defaultModel = {
			// id: '',
			name: '',
			accountingId: '',
			status: true,
			_address: '',
			_address2: '',
			_city: '',
			_state: null,
			_zip: '',
			_POC: '',
			_phone: '',
			_email: '',
			effectiveDate: null,
			expirationDate: null,
			today: moment.utc().format(),
			billingStatus: false,
			servicePriority: false,
			onDemandPickup: false,
			orderCutoff: false,
			orderCutoffDays: null,
			orderCutoffTime: null,
			serviceEmail: '',
			billToContractTransportId: null,
			billToContractDepositId: null,
			billToContractChangeOrderId: null,
			billToContractATMServiceId: null,
			billToContractCashHandlingId: null,
			billToContractMaintenanceId: null,
			sameForAll: false,
			billToContractTransportStatus: true,
			billToContractDepositStatus: true,
			billToContractChangeOrderStatus: true,
			billToContractATMServiceStatus: true,
			billToContractCashHandlingStatus: true,
			billToContractMaintenanceStatus: true,
			selectedFiles: [],
			annualIncrease: null,
			contractPocName: '',
			contractPocEmail:'',
			contractAddress:'',
			contractCity:'',
			contractState:null,
			contractZip:'',
			contractPocPhone:'',
			contractTypeObj: {
				totalRecords: 0,
				results: [],
				loading: false
			},
			contractPaymentMethod:'',
			contractType: null,
			surcharges: this.buildDefaultSurcharges()
		}

		this.model = angular.copy(this.defaultModel);
		this.model.customerContracts = []
		this.customers = [];
		this.contracts = [];

		this.statuses = [{
			label: 'Active',
			value: 'active'
		},
		{
			label: 'Inactive',
			value: 'inactive'
		}]

		this.toggleSwitchUI = {
			size: 'small',
			label: {
				on: this.$translate.instant('common.yes'),
				off: this.$translate.instant('common.no'),
			},
			onColor: 'success',
			offColor: 'danger'
		}

		this.serviceSchedule = [{
			label: this.$translate.instant('location.mon'),
			model: 'serviceScheduleMon'
		},
		{
			label: this.$translate.instant('location.tues'),
			model: 'serviceScheduleTue'
		},
		{
			label: this.$translate.instant('location.wed'),
			model: 'serviceScheduleWed'
		},
		{
			label: this.$translate.instant('location.thurs'),
			model: 'serviceScheduleThu'
		},
		{
			label: this.$translate.instant('location.fri'),
			model: 'serviceScheduleFri'
		},
		{
			label: this.$translate.instant('location.sat'),
			model: 'serviceScheduleSat'
		},
		{
			label: this.$translate.instant('location.sun'),
			model: 'serviceScheduleSun'
		},
		{
			label: this.$translate.instant('location.hol'),
			model: 'serviceScheduleHol'
		}]

		this.states = [
			"Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado",
			"Connecticut", "Delaware", "District Of Columbia", "Federated States Of Micronesia",
			"Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
			"Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts",
			"Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
			"New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
			"Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico",
			"Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
			"Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
		];

		this.branchId = this.User.getUser().branchId;
		this.languageId = this.User.getUser().languageId;
		this.billingCategoryObj = {};
		this.loggedInUser = this.User.getUser().id;
		this.paymentMethodList = CommonLayoutService.paymentMethod();

		this.contractIdKeyObj = {
			transport: 'Transport',
			deposit: 'Deposit',
			changeOrder: 'ChangeOrder',
			ATMService: 'ATMService',
			cashHandling: 'CashHandling',
			maintenance: 'Maintenance'
		}
	}

	isDisabledDate = function (currentDate, mode) {
		if (this.model.expirationDate !== null) {
			if (this.model.effectiveDate > this.model.expirationDate) {
				this.model.expirationDate = this.model.effectiveDate
			}
			else if (this.model.effectiveDate == null) {
				this.model.expirationDate = null
			}
		}

		this.effectiveMinDate = {
			minDate: this.model.effectiveDate
		}
	}

	$onInit() {
		this.$q.all([
			this.ContractService.all(null, 0, LIMIT),
			this.getContractType('', 0),
			this.getBillingEventOptions()
		])
			.then((data) => {
				this.contracts = this.mappingContractDatas(data[0].results);
				this.totalContract = data[0].total;
				this.billingEventOptions = data[2];
				this.applySurchargeOptions(this.model.surcharges, this.billingEventOptions);

				this.todayMinDate = {
					minDate: this.model.today
				}
				this.effectiveMinDate = {
					minDate: this.model.effectiveDate
				}
			})
			.catch((err) => {
				this.error = err.message;
			})
			.finally(() => {
				this.loading = false;
			});
	}

	reset() {
		this.model = angular.copy(this.defaultModel);
		this.getContractType('',0);
		this.applySurchargeOptions(this.model.surcharges, this.billingEventOptions);
		this.clearErrors();
	}

	delete(index) {
		let contract = this.model.customerContracts[index]
		this.confirmDelete(contract, index)
	}

	confirmDelete(contract, index) {
		this.Modal.confirm({
			header: this.$translate.instant(this.id + '.delete_title'),
			message: this.$translate.instant(this.id + '.delete_message'),
			callback: ({
				modal
			}) => {
				this.model.customerContracts.splice(index, 1)
				modal.close()
			},
			negative: ({
				modal
			}) => {
				modal.close()
			},
			type: 'primary',
			buttons: ['common.yes', 'common.no']
		})
	}

	toggleDay(day) {
		this.model[day.model] = !this.model[day.model]
	}

	resetCustomerOrderLeadData() {
		if (!this.model.orderCutoff) {
			this.model.orderCutoffDays = null;
			this.model.orderCutoffTime = null;
		}
	}

	isDaySelected(day) {
		return this.model[day.model];
	}

	submit(evt) {
		this.loading = true;

		const { customerFields, surchargeBillingEvents } = this.mapSurchargesForSubmit(this.model.surcharges);

		this.Service.create({
			// id: this.model.id,
			...customerFields,
			name: this.model.name,
			contact: this.model.contact,
			accountingId: this.model.accountingId,
			isEnabled: this.model.status,
			billingAddress: this.model._address,
			billingAddress2: this.model._address2,
			billingState: this.model._state,
			billingCity: this.model._city,
			billingZip: this.model._zip,
			billingPhone: this.model._phone,
			billingEmail: this.model._email,
			billingPOC: this.model._POC,
			billingStatus: this.model.billingStatus,
			servicePriority: this.model.servicePriority,
			onDemandPickup: this.model.onDemandPickup,
			orderCutoff: this.model.orderCutoff,
			orderCutoffDays: this.model.orderCutoff && this.model.orderCutoffDays !== null && this.model.orderCutoffDays !== ''
				? parseInt(this.model.orderCutoffDays, 10) : null,
			orderCutoffTime: this.model.orderCutoff && this.model.orderCutoffTime
				? moment(this.model.orderCutoffTime).format('HH:mm:ss') : null,
			serviceEmail: this.model.serviceEmail,
			effectiveDate: this.model.effectiveDate ? this.model.effectiveDate : null,
			expirationDate: this.model.expirationDate ? this.model.expirationDate : null,
			serviceScheduleMon: this.model.serviceScheduleMon,
			serviceScheduleTue: this.model.serviceScheduleTue,
			serviceScheduleWed: this.model.serviceScheduleWed,
			serviceScheduleThu: this.model.serviceScheduleThu,
			serviceScheduleFri: this.model.serviceScheduleFri,
			serviceScheduleSat: this.model.serviceScheduleSat,
			serviceScheduleSun: this.model.serviceScheduleSun,
			serviceScheduleHol: this.model.serviceScheduleHol,
			billToContractTransportId: this.model.billToContractTransportId ? this.model.billToContractTransportId.value : null,
			billToContractDepositId: this.model.billToContractDepositId ? this.model.billToContractDepositId.value : null,
			billToContractChangeOrderId: this.model.billToContractChangeOrderId ? this.model.billToContractChangeOrderId.value : null,
			billToContractATMServiceId: this.model.billToContractATMServiceId ? this.model.billToContractATMServiceId.value : null,
			billToContractCashHandlingId: this.model.billToContractCashHandlingId ? this.model.billToContractCashHandlingId.value : null,
			billToContractMaintenanceId: this.model.billToContractMaintenanceId ? this.model.billToContractMaintenanceId.value : null,
			contractDocuments: this.model.selectedFiles.filter((d) => delete d._file),
			annualIncrease: this.model.annualIncrease ? this.convertStr(this.model.annualIncrease) : null,
			POCName: this.model.contractPocName,
			address: this.model.contractAddress,
			city: this.model.contractCity,
			state: this.model.contractState,
			zip: this.model.contractZip,
			POCEmail: this.model.contractPocEmail,
			POCPhone: this.model.contractPocPhone,
			paymentMethod: this.model.paymentMethod,
			contractTypeId: this.model.contractType,
			surchargeBillingEvents
		}, this.branchId, this.loggedInUser)
			.then((data) => {
				if (this.model.createNewLocation) {
					const locationModel = {
						customer: this.model.id,
						_address: this.model._address,
						_city: this.model._city,
						_state: this.model._state,
						_zip: this.model._zip,
						_poc: this.model._POC,
						pocPhone: this.model._phone,
						pocEmail: this.model._email,
					};
					this.createLocation(locationModel);
				} else {
					this.loading = false;
					this.askCreate();
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
				else {
					this.errorMessage += err.data.message + '<br/>'
				}
			})
			.finally(() => {
				this.loading = false;
			})
	}

	createLocation(locationModel) {
		this.Modal.addLocation(locationModel, ({ modal, data }) => {
			//close modal
			modal.close();
			this.loading = false;
			this.askCreate();
		}, ({ modal }) => {
			modal.close();
			this.loading = false;
			this.askCreate()
		})
	}

	mappingContractDatas(contracts) {
		return contracts.map((contract) => {
			return {
				value: contract.id,
				title: contract.id,
				names: contract.contractName,
				Key: contract.id + ' | ' + contract.contractName,
				Value: contract.id
			};
		})
	}

	loadContractData(searchKey, offset) {
		let loadDatas = null;
		if (searchKey) {
			const searchObj = {
				queryText: '%' + searchKey + '%',
				isQuery: false
			}
			loadDatas = searchObj;
		}

		this.ContractService.all(loadDatas, offset, LIMIT)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.contracts = this.mappingContractDatas(data.results);
					this.totalContract = data.total;
				} else {
					const contracts = this.mappingContractDatas(data.results);
					this.contracts = this.contracts.concat(contracts);
					this.totalContract = data.total;
				}
			})
			.catch((err) => {
				console.log(err);
			})
	}

	resetBillingCategory(type) {
		if (!this.model[`billToContract${type}status`]) this.model[`billToContract${type}Id`] = null;
	}

	sameForAll(value) {
		if (this.model.sameForAll) {
			Object.values(this.contractIdKeyObj).forEach(key => {
				this.model[`billToContract${key}Id`] = value;
			})
		}
	}

	getBillingRulesInfo(type) {
		const contractId = this.model[`billToContract${type}Id`];
		const contractInfo = [];

		if (!contractId) return;

		if (this.model.sameForAll) {
			Object.values(this.contractIdKeyObj).forEach(key => {
				this.billingCategoryObj[`billToContract${key}Id`] = { process: true };
				contractInfo.push({
					type: key,
					contractId: contractId.value
				})
			})
		}
		else {
			this.billingCategoryObj[`billToContract${type}Id`] = { process: true };
			contractInfo.push({
				type,
				contractId: contractId.value
			})
		}

		this.Service.getBillingRulesInfo(this.languageId, contractInfo)
			.then((data) => {
				if (this.model.sameForAll) {
					Object.values(this.contractIdKeyObj).forEach(key => {
						this.billingCategoryObj[`billToContract${key}Id`].details = data[type];
					})
				}
				else this.billingCategoryObj[`billToContract${type}Id`].details = data[type];
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				if (this.model.sameForAll) {
					Object.values(this.contractIdKeyObj).forEach(key => {
						this.billingCategoryObj[`billToContract${key}Id`].process = false;
					})
				}
				else this.billingCategoryObj[`billToContract${type}Id`].process = false;
			})
	}

	uploadContractDocuments(stat) {
		this.Modal.uploadContractDocuments(stat, _.cloneDeep(this.model.selectedFiles), ({ modal, data, $scope }) => {
			$scope.model.loading = false;
			this.model.selectedFiles = data;
			modal.close();
		}, ({ modal, data }) => {
			this.model.selectedFiles = data;
			if (modal) modal.close();
		})
	}

	ngPercentage() {
		if (this.model.annualIncrease && !this.model.annualIncrease.endsWith('%')) {
			return this.model.annualIncrease = this.model.annualIncrease + '%';
		}
	}

	removePrecentageSign() {
		if (this.model.annualIncrease && this.model.annualIncrease.endsWith('%')) {
			return this.model.annualIncrease = this.model.annualIncrease.replace('%', '');
		}
	}

	convertStr(str) {
		if (!str) return;
		return Number(str.replace('%', ''));
	}

	getContractType(searchKey, offset) {
		searchKey = searchKey || '';
	
		const obj = {
			queryJSON: {
				rules: [
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "type",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}

        this.model.contractTypeObj.loading = true;
        this.ContractTypeService.all(obj,offset, AppConstants.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.contractTypeObj.totalRecords = data.total;
                    this.model.contractTypeObj.results = this.contractTypeMap(data.results);
                }
                else {
                    const results = this.contractTypeMap(data.results);
                    this.model.contractTypeObj.results = this.model.contractTypeObj.results.concat(results);
                }
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.contractTypeObj.loading = false;
            })
    }

    contractTypeMap(events) {
        return events.map((data) => {
            return {
                Key: data.type,
                Value: data.id
            }
        });
    }

}

export default CustomerCreateController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/create/customer.create.controller.js